import React from "react";
import date from "../../Assets/images/date.svg";
import time from "../../Assets/images/time.svg";
import { useNavigate } from "react-router-dom";

const ListingCard = ({ data, latestFirst = true }) => {
  const navigate = useNavigate();
  
  // Function to truncate HTML content while preserving HTML structure
  const truncateHTML = (html, maxLength = 150) => {
    if (!html || typeof window === 'undefined') return html || "";
    
    try {
      // Strip HTML to get text length
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      const textContent = tempDiv.textContent || tempDiv.innerText || "";
      
      // If content is short enough, return as is
      if (textContent.length <= maxLength) {
        return html;
      }
      
      // Truncate by finding a good breaking point in the HTML
      let charCount = 0;
      let result = "";
      let inTag = false;
      let tagBuffer = "";
      let inEntity = false;
      let entityBuffer = "";
      const openTags = [];
      
      for (let i = 0; i < html.length; i++) {
        const char = html[i];
        
        if (char === "<") {
          // If we're in an entity, finish it first
          if (inEntity) {
            result += entityBuffer;
            inEntity = false;
            entityBuffer = "";
          }
          inTag = true;
          tagBuffer = char;
        } else if (char === ">") {
          inTag = false;
          tagBuffer += char;
          const fullTag = tagBuffer.toLowerCase();
          
          // Check if it's a closing tag
          if (fullTag.startsWith("</")) {
            const tagName = fullTag.match(/<\/(\w+)/)?.[1];
            if (tagName && openTags.includes(tagName)) {
              openTags.splice(openTags.indexOf(tagName), 1);
            }
            result += tagBuffer;
          } else if (!fullTag.endsWith("/>")) {
            // Opening tag (not self-closing)
            const tagName = fullTag.match(/<(\w+)/)?.[1];
            if (tagName) {
              openTags.push(tagName);
            }
            result += tagBuffer;
          } else {
            // Self-closing tag
            result += tagBuffer;
          }
          tagBuffer = "";
        } else if (inTag) {
          tagBuffer += char;
        } else if (char === "&" && !inEntity) {
          // Start of HTML entity
          inEntity = true;
          entityBuffer = char;
        } else if (inEntity) {
          entityBuffer += char;
          if (char === ";") {
            // End of HTML entity - add it completely
            result += entityBuffer;
            charCount++; // Count entity as one character
            inEntity = false;
            entityBuffer = "";
          }
        } else {
          // Regular text character
          if (charCount < maxLength) {
            result += char;
            charCount++;
          } else {
            // If we're in the middle of an entity, finish it or remove it
            if (inEntity) {
              // Remove partial entity
              inEntity = false;
              entityBuffer = "";
            }
            // Add ellipsis and close any open tags
            result += "...";
            // Close tags in reverse order
            for (let j = openTags.length - 1; j >= 0; j--) {
              result += `</${openTags[j]}>`;
            }
            break;
          }
        }
      }
      
      // If we ended while still in an entity, remove the partial entity
      if (inEntity) {
        // Don't add partial entity
      }
      
      return result || html.substring(0, maxLength) + "...";
    } catch (error) {
      // Fallback: simple truncation
      const textOnly = html.replace(/<[^>]*>/g, "");
      return textOnly.length > maxLength 
        ? textOnly.substring(0, maxLength) + "..." 
        : html;
    }
  };

  // function formatDate(isoString) {
  //     const date = new Date(isoString);

  //     const day = date.getDate();
  //     const year = date.getFullYear();

  //     const monthNames = [
  //         "January", "February", "March", "April", "May", "June",
  //         "July", "August", "September", "October", "November", "December"
  //     ];
  //     const month = monthNames[date.getMonth()];

  //     return `${day} ${month}, ${year}`;
  // }

  const sortedData = [...data].sort((a, b) => {
    return latestFirst
      ? new Date(b.create_dt) - new Date(a.create_dt)
      : new Date(a.create_dt) - new Date(b.create_dt);
  });

  const handleViewDetail = async (id) => {
    navigate(`/tableeghat/${id}`);
  };

  return (
    <div dir="rtl" className="flex flex-col text-start gap-5 mt-5">
      {sortedData.map((item) => (
        <div
          key={item.id}
          className="cursor-pointer mar py-4 border-b border-gray-200 transition-all duration-300 hover:scale-[1.02]"
          onClick={() => handleViewDetail(item.id)}
        >
          {/* Category */}
          <p className="bg-textBG px-3 py-2 rounded-lg text-black text-lg sm:text-lg md:text-xl lg:text-xl w-fit">
            {item.category}
          </p>

          {/* Title */}
          <h2 className="font-nastaleeqKasheeda my-3 text-lg sm:text-xl md:text-2xl lg:text-2xl">
            {item.title}
          </h2>

          {/* Metadata */}
          <div className="flex items-center gap-x-3 text-xs text-gray-600 mt-2">
            <div className="flex items-center gap-x-1 border-l pl-2 mb-2">
              <img src={date} alt="Date" className="w-3 h-3" />
              <span dir="ltr">
                {item.article_type}-{item?.yearData?.year}
              </span>
            </div>
            {item?.read_min && (
              <div className="flex items-center gap-x-1 pl-2 mb-2">
                <img src={time} alt="Time" className="w-3 h-3" />
                <span className="mx-1">{item.read_min}</span>
                منٹ پڑھنے کا وقت
              </div>
            )}
          </div>

          {/* Content preview */}
          <div
            className="w-full text-right text-sm sm:text-base md:text-base lg:text-lg font-nastaleeqRegular group mt-2"
            dangerouslySetInnerHTML={{
              __html: truncateHTML(item.content, 150),
            }}
          />
        </div>
      ))}
    </div>
  );
};
export default ListingCard;
